var video_column_controller = {
    instances: {},
    video_html: '<video id="v-{{id}}" class="hidden" preload="metadata" autoplay controls playsinline><source src="{{video_source}}" type="video/mp4"></video>',
    modal_html: '<div class="video-modal" id="vm-{{id}}"><video class="hidden" poster="{{poster}}" preload="metadata" autoplay playsinline controls><source src="{{video_source}}" type="video/mp4"></video><button type="button" aria-label="Close Modal" class="fa fa-times"></button></div>',
    iframe_modal_html: '<div id="if-vm-{{id}}" class="video-modal">{{video}}<button type="button" aria-label="Close Modal" class="icon icon-close-x-circle"></button></div>',
    iframe_html: '<iframe id="if-{{id}}" allow="autoplay *; fullscreen *" src="{{video_source}}" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen="" width="{{width}}" height="{{height}}" frameborder="0"></iframe>',
    vimeo_params: '?autoplay=1&loop=0&title=0&byline=0&portait=0',
    vimeo_params_obj: {
        autoplay: 1,
        loop: 0,
        title: 0,
        byline: 0,
        portait: 0
    },
    aspect_ratio: 0.5625, //16:9 Aspect Ratio
    h_aspect_ratio: 1.7778,
    pause_icon: 'icon icon-pause',
    play_icon: 'icon icon-play',
    init: function(selector){
        if(typeof video_column_controller.instances[selector] != 'undefined'){
            var video = video_column_controller.instances[selector].video;
            var instance = video_column_controller.instances[selector].$dom;
            var button = instance.find('button[aria-label="play video"]');
            var video_dom = video[0];
            if(!video_dom.paused){
                video_dom.pause();
                button.attr('class', video_column_controller.play_icon);
            }else{
                video_dom.play();
                button.attr('class', video_column_controller.pause_icon);
            }
            return;
        }
        var instance = jQuery(selector);
        var button = instance.find('button[aria-label="play video"]');
        button.attr('class', video_column_controller.pause_icon);
        var src = video_column_controller.get_source(instance);
        var poster = instance.find('img').attr('src');
        var id = instance.attr('id');
        var video = jQuery(video_column_controller.video_html.replace('{{poster}}', poster).replace('{{video_source}}', src).replace('{{width}}', '').replace('{{height}}', '').replace('{{id}}', id));
        var sizing = video_column_controller.get_height(instance);
        //video.css('height', sizing.height + 'px');
        if(typeof sizing.width != 'undefined'){
            //video.css('width', sizing.width + 'px');
        }
        video.on('load', function(){
            jQuery(this).removeClass('hidden');
            if(!instance.hasClass('playing')){
                instance.addClass('playing');
            }
        });
        instance.append(video);
        setTimeout(function(){
            var video_dom = video[0];
            const isVideoPlaying = video_dom => !!(video_dom.currentTime > 0 && !video_dom.paused && !video_dom.ended && video_dom.readyState > 2);
            if(isVideoPlaying){
                video.removeClass('hidden');
                var inner_instance = video.closest('.column-video');
                if(!inner_instance.hasClass('playing')){
                    inner_instance.addClass('playing');
                }
            }
        }, 100);
        video_column_controller.instances[selector] = {
            $dom: instance,
            $button: button,
            src: src,
            poster: poster,
            video: video,
            id: id
        };
    },
    popout_init: function(selector){
        var instance = jQuery(selector);
        var button = instance.find('button[aria-label="play video"]');
        var src = video_column_controller.get_source(instance);
        var poster = instance.find('img').attr('src');
        var video = jQuery(video_column_controller.modal_html.replace('{{poster}}', poster).replace('{{video_source}}', src).replace('{{id}}', instance.attr('id')));
        video.on('load', function(){
            jQuery(this).removeClass('hidden');
            if(!instance.hasClass('playing')){
                instance.addClass('playing');
            }
        });
        jQuery('body').append(video);
        video.find('button[aria-label="Close Modal"]').click(function(){
            video.find('video')[0].pause();
            video.remove();
        });
        setTimeout(function(){
            var video_dom = video[0];
            const isVideoPlaying = video_dom => !!(video_dom.currentTime > 0 && !video_dom.paused && !video_dom.ended && video_dom.readyState > 2);
            if(isVideoPlaying){
                video.removeClass('hidden');
                var inner_instance = video.closest('.column-video');
                if(!inner_instance.hasClass('playing')){
                    inner_instance.addClass('playing');
                }
            }
        }, 100);
        video_column_controller.instances[selector] = {
            $dom: instance,
            $button: button,
            src: src,
            poster: poster,
            video: video
        };
    },
    iframe_inline_init: function(selector){
        if(typeof video_column_controller.instances[selector] != 'undefined'){
            var video = video_column_controller.instances[selector].video;
            var instance = video_column_controller.instances[selector].$dom;
            var button = instance.find('button[aria-label="play video"]');
            var video_dom = video[0];
            if(!video_dom.paused){
                video_dom.pause();
                button.attr('class', video_column_controller.play_icon);
            }else{
                video_dom.play();
                button.attr('class', video_column_controller.pause_icon);
            }
            return;
        }
        var instance = jQuery(selector);
        var button = instance.find('button[aria-label="play video"]');
        button.attr('class', video_column_controller.pause_icon);
        var src = video_column_controller.get_source(instance);
        src = video_column_controller.param_set_vimeo_keys(src);
        var poster = instance.find('img').attr('src');
        var video_string = video_column_controller.iframe_html.replace('{{poster}}', poster).replace('{{video_source}}', src).replace('{{width}}', '').replace('{{height}}', '').replace('{{id}}', instance.attr('id'));
        var sizing = video_column_controller.get_height(instance);
        //video.css('height', sizing.height + 'px');
        if(typeof sizing.width != 'undefined'){
            //video_string = video_string.replace('{{width}}', sizing.width).replace('{{height}}', sizing.height);
        }else{
            //video_string = video_string.replace('{{height}}', sizing.height);
            //video_string = video_string.replace('{{width}}', instance.outerWidth());
        }
        var video = jQuery(video_string);
        //video.css('height', video.attr('height') + 'px');
        //video.css('width', video.attr('width') + 'px');
        video.on('load', function(){
            jQuery(this).removeClass('hidden');
            if(!instance.hasClass('playing')){
                instance.addClass('playing');
            }
        });
        //console.log(video);
        instance.append(video);
    },
    atag_popout_init: function(selector){
        var instance = jQuery(selector);
        var src = video_column_controller.get_source(instance);
        var video_string = video_column_controller.iframe_html.replace('{{poster}}', '').replace('{{video_source}}', src).replace('{{width}}', '').replace('{{height}}', '').replace('{{id}}', '');
        video_string = video_column_controller.iframe_modal_html.replace('{{video}}', video_string).replace('{{id}}', '');
        var video = jQuery(video_string);
        video.on('load', function(){
            jQuery(this).removeClass('hidden');
            if(!instance.hasClass('playing')){
                instance.addClass('playing');
            }
        });
        video.find('button[aria-label="Close Modal"]').click(function(){
            video.remove();
        });
        jQuery('body').append(video);
    },
    iframe_popout_init: function(selector){
        var instance = jQuery(selector);
        var button = instance.find('button[aria-label="play video"]');
        var src = video_column_controller.get_source(instance);
        if(src.indexOf('vimeo') > -1){
            src = video_column_controller.param_set_vimeo_keys(src);
        }
        var poster = instance.find('img').attr('src');
        var video_string = video_column_controller.iframe_html.replace('{{poster}}', poster).replace('{{video_source}}', src).replace('{{width}}', '').replace('{{height}}', '').replace('{{id}}', instance.attr('id')).off('click');
        video_string = video_column_controller.iframe_modal_html.replace('{{video}}', video_string);
        var video = jQuery(video_string);
        video.on('load', function(){
            jQuery(this).removeClass('hidden');
            if(!instance.hasClass('playing')){
                instance.addClass('playing');
            }
        });
        video.find('button[aria-label="Close Modal"]').click(function(){
            video.remove();
        });
        jQuery('body').append(video);
        setTimeout(function(){
            var video_dom = video[0];
            const isVideoPlaying = video_dom => !!(video_dom.currentTime > 0 && !video_dom.paused && !video_dom.ended && video_dom.readyState > 2);
            if(isVideoPlaying){
                video.removeClass('hidden');
                var inner_instance = video.closest('.column-video');
                if(!inner_instance.hasClass('playing')){
                    inner_instance.addClass('playing');
                }
            }
        }, 100);
        video_column_controller.instances[selector] = {
            $dom: instance,
            $button: button,
            src: src,
            poster: poster,
            video: video
        };
    },
    get_height: function($dom){
        var min_height = $dom.innerHeight(true);
        var height = $dom.innerWidth();
        height = height * video_column_controller.h_aspect_ratio;
        if(height < min_height){
            height = min_height;
            var width = height * video_column_controller.h_aspect_ratio;
            return {
                height: height,
                width: width,
                overflow: true
            }
        }else{
            return {
                height: height,
                overflow: false
            }

        }
    },
    get_source: function($instance){
        var window_width = jQuery(window).width();
        if($instance.is('a')){
            var href = $instance.attr('href');
            return href;
        }
        var src_select = 'src';
        if(
            (window_width <= 768)
            && $instance.data('src-tab') != ''
        ){
            src_select = 'src-tab';
        }
        if(
            (window_width <= 480)
            && $instance.data('src-mob') != ''
        ){
            src_select = 'src-mob';
        }
        var src = $instance.data(src_select);
        return src;
    },
    param_set_vimeo_keys: function(src){
        var existing_params = video_column_controller.param_parse(src);
        var params_to_set = video_column_controller.vimeo_params_obj;
        for(var param in params_to_set){
            existing_params.params.set(param, params_to_set[param]);
        }
        var new_params = existing_params.params.toString();
        var new_url = existing_params.url.origin + existing_params.url.pathname + existing_params.url.hash + '?' + new_params;
        return new_url;
    },
    param_parse: function(url){
        var url = new URL(url);
        var params = new URLSearchParams(url.search);
        var to_return = {
            'url': url,
            'params': params
        };
        return to_return;
    },
};

window.video_column_controller = video_column_controller;

jQuery(document).ready(function(){
    jQuery('.column-video:not(.popout):not(.iframe) .controls button[aria-label="play video"]').off('click').click(function(){
        video_column_controller.init(jQuery(this).closest('.column-video')[0]);
    });
    jQuery('.column-video.popout:not(.iframe) button').off('click').click(function(){
        video_column_controller.popout_init(jQuery(this).closest('.column-video')[0]);
    });
    jQuery('body').on('click', 'a[href*="player.vimeo.com"], a[href*="youtube.com/embed"]', function(e){
        e.preventDefault();
        video_column_controller.atag_popout_init(jQuery(this)[0]);
    });
    jQuery('.column-video.iframe.inline .controls button[aria-label="play video"]').off('click').click(function(){
        video_column_controller.iframe_inline_init(jQuery(this).closest('.column-video')[0]);
    });
    jQuery('.column-video.iframe.popout .controls button[aria-label="play video"]').off('click').click(function(){
        video_column_controller.iframe_popout_init(jQuery(this).closest('.column-video')[0]);
    });
    jQuery('.column-video.inline-auto-play .controls button[aria-label="play video"]').trigger('click');
});